import { Stack, Typography } from '@mui/material';
import CustomAreaChart from '../../components/CustomAreaChart';

const acceleratorDomain = [-10, 10]; //see https://recharts.org/en-US/api/YAxis domain
const gyroDomain = [-5, 5]; //see https://recharts.org/en-US/api/YAxis domain

export function ArmsMobile({ arms, deviceDescription }) {
  const isAppleDevice = !deviceDescription;

  const scaleAcceleratorData = (data) => {
    const accel = data.accel.map((d) => ({ ...d, x: d.x * 9.8, y: d.y + 9.8, z: d.z * 9.8 }));
    return isAppleDevice ? { ...data, accel } : data;
  };

  const normalizeArmsData = (data, device) => {
    data = data[device];
    data = data.map((obj) => {
      return { val: Math.sqrt(Math.pow(obj.x, 2) + Math.pow(obj.y, 2) + Math.pow(obj.z, 2)), timestamp: obj.timestamp };
    });
    //Zero mean - we make the values linger around the horisontal axis by substracting the avg value from each one.
    const avgVal = data.reduce((a, b) => a + b.val, 0) / data.length;
    const timestamps = data.map((obj) => obj.timestamp);
    const minTS = Math.min(...timestamps);
    data = data.map((obj) => {
      return {
        timestamp: obj.timestamp - minTS,
        val: obj.val - avgVal,
      };
    });
    return data;
  };

  return (
    <>
      <Stack sx={{ overflowX: 'scroll', overflowY: 'scroll', paddingLeft: '5px', paddingRight: '5px' }}>
        <Typography
          sx={{
            fontSize: '1.7em',
          }}
        >
          Accelerometer
        </Typography>
        <Typography
          component="h5"
          sx={{
            fontSize: '1.5em',
            paddingLeft: '5px',
          }}
        >
          Left Arm
        </Typography>
        {arms.left.accel.length > 0 ? <CustomAreaChart domain={acceleratorDomain} width={490} data={normalizeArmsData(scaleAcceleratorData(arms.left), 'accel')} x_label="timestamp" y_label="val"></CustomAreaChart> : ''}

        <Typography
          component="h5"
          sx={{
            fontSize: '1.5em',
            paddingLeft: '5px',
          }}
        >
          Right Arm
        </Typography>
        {arms.right.accel.length > 0 ? <CustomAreaChart domain={acceleratorDomain} width={490} data={normalizeArmsData(scaleAcceleratorData(arms.right), 'accel')} x_label="timestamp" y_label="val"></CustomAreaChart> : ''}

        <Typography
          component="h5"
          sx={{
            fontSize: '1.7em',
          }}
        >
          Gyroscope
        </Typography>
        <Typography
          component="h5"
          sx={{
            fontSize: '1.5em',
            paddingLeft: '5px',
          }}
        >
          Left Arm
        </Typography>
        {arms.left.gyro.length > 0 ? <CustomAreaChart domain={gyroDomain} width={490} data={normalizeArmsData(arms.left, 'gyro')} x_label="timestamp" y_label="val"></CustomAreaChart> : ''}

        <Typography
          component="h5"
          sx={{
            fontSize: '1.5em',
            paddingLeft: '5px',
          }}
        >
          Right Arm
        </Typography>
        {arms.right.gyro.length > 0 ? <CustomAreaChart domain={gyroDomain} width={490} data={normalizeArmsData(arms.right, 'gyro')} x_label="timestamp" y_label="val"></CustomAreaChart> : ''}

        <Typography
          component="h5"
          sx={{
            fontSize: '1.7em',
          }}
        >
          Magnetometer
        </Typography>
        <Typography
          component="h5"
          sx={{
            fontSize: '1.5em',
            paddingLeft: '5px',
          }}
        >
          Left Arm
        </Typography>
        {arms.left.magnet.length > 0 ? <CustomAreaChart width={490} data={normalizeArmsData(arms.left, 'magnet')} x_label="timestamp" y_label="val"></CustomAreaChart> : ''}

        <Typography
          component="h5"
          sx={{
            fontSize: '1.5em',
            paddingLeft: '5px',
          }}
        >
          Right Arm
        </Typography>
        {arms.right.magnet.length > 0 ? <CustomAreaChart width={490} data={normalizeArmsData(arms.right, 'magnet')} x_label="timestamp" y_label="val"></CustomAreaChart> : ''}
      </Stack>
    </>
  );
}
